import React from "react";

export default function CardBody({ className, plain, profile, style, ...rest }) {
  return (
    <div style={{padding: "0.9375rem 20px", flex: "1 1 auto", position: "relative", ...style, }} {...rest} />
  );
}
